"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseGrid = void 0;
const GridStyle_1 = require("./GridStyle");
/**
 * Base Grid
 */
class BaseGrid {
    constructor() {
        /**
         * Enabled grid
         */
        this.enabled = false;
        /**
         * Minimum zoom level
         */
        this.minZoom = 0;
        /**
         * Grid line style
         */
        this.style = new GridStyle_1.GridStyle(undefined, 0);
    }
    /**
     * Is the grid enabled
     *
     * @return enabled flag
     */
    isEnabled() {
        return this.enabled;
    }
    /**
     * Set the enabled flag
     *
     * @param enabled
     *            enabled flag
     */
    setEnabled(enabled) {
        this.enabled = enabled;
    }
    /**
     * Get the minimum zoom level
     *
     * @return minimum zoom level
     */
    getMinZoom() {
        return this.minZoom;
    }
    /**
     * Set the minimum zoom level
     *
     * @param minZoom
     *            minimum zoom level
     */
    setMinZoom(minZoom) {
        this.minZoom = minZoom;
    }
    /**
     * Get the maximum zoom level
     *
     * @return maximum zoom level
     */
    getMaxZoom() {
        return this.maxZoom;
    }
    /**
     * Has a maximum zoom level
     *
     * @return true if has a maximum, false if unbounded
     */
    hasMaxZoom() {
        return this.maxZoom !== undefined;
    }
    /**
     * Set the maximum zoom level
     *
     * @param maxZoom
     *            maximum zoom level
     */
    setMaxZoom(maxZoom) {
        this.maxZoom = maxZoom;
    }
    /**
     * Is the zoom level within the grid zoom range
     *
     * @param zoom
     *            zoom level
     * @return true if within range
     */
    isWithin(zoom) {
        return zoom >= this.minZoom && (this.maxZoom === undefined || zoom <= this.maxZoom);
    }
    /**
     * Get the minimum zoom level for drawing grid lines
     *
     * @return minimum zoom level
     */
    getLinesMinZoom() {
        return this.linesMinZoom !== undefined ? this.linesMinZoom : this.getMinZoom();
    }
    /**
     * Has a minimum zoom level override for drawing grid lines
     *
     * @return true if has a minimum, false if not overridden
     */
    hasLinesMinZoom() {
        return this.linesMinZoom !== undefined;
    }
    /**
     * Set the minimum level override for drawing grid lines
     *
     * @param linesMinZoom
     *            minimum zoom level or undefined to remove
     */
    setLinesMinZoom(linesMinZoom) {
        this.linesMinZoom = linesMinZoom;
    }
    /**
     * Get the maximum zoom level for drawing grid lines
     *
     * @return maximum zoom level
     */
    getLinesMaxZoom() {
        return this.linesMaxZoom !== undefined ? this.linesMaxZoom : this.getMaxZoom();
    }
    /**
     * Has a maximum zoom level override for drawing grid lines
     *
     * @return true if has a maximum, false if not overridden
     */
    hasLinesMaxZoom() {
        return this.linesMaxZoom !== undefined;
    }
    /**
     * Set the maximum level override for drawing grid lines
     *
     * @param linesMaxZoom
     *            maximum zoom level or undefined to remove
     */
    setLinesMaxZoom(linesMaxZoom) {
        this.linesMaxZoom = linesMaxZoom;
    }
    /**
     * Is the zoom level within the grid lines zoom range
     *
     * @param zoom
     *            zoom level
     * @return true if within range
     */
    isLinesWithin(zoom) {
        let isWithin = true;
        if (this.linesMinZoom !== null && this.linesMinZoom !== undefined) {
            isWithin = zoom >= this.linesMinZoom;
        }
        if (isWithin && this.linesMaxZoom !== null && this.linesMaxZoom !== undefined) {
            isWithin = zoom <= this.linesMaxZoom;
        }
        return isWithin;
    }
    /**
     * Get the grid line style
     *
     * @return grid line style
     */
    getStyle() {
        return this.style;
    }
    /**
     * Set the grid line style
     *
     * @param style
     *            grid line style
     */
    setStyle(style) {
        this.style = style !== undefined ? style : new GridStyle_1.GridStyle(undefined, 0);
    }
    /**
     * Get the grid line color
     *
     * @return grid line color
     */
    getColor() {
        return this.getStyle().getColor();
    }
    /**
     * Set the grid line color
     *
     * @param color
     *            grid line color
     */
    setColor(color) {
        this.getStyle().setColor(color);
    }
    /**
     * Get the grid line width
     *
     * @return grid line width
     */
    getWidth() {
        return this.getStyle().getWidth();
    }
    /**
     * Set the grid line width
     *
     * @param width
     *            grid line width
     */
    setWidth(width) {
        this.getStyle().setWidth(width);
    }
    /**
     * Get the grid labeler
     *
     * @return grid labeler
     */
    getLabeler() {
        return this.labeler;
    }
    /**
     * Has a grid labeler
     *
     * @return true if has a grid labeler
     */
    hasLabeler() {
        return this.labeler !== undefined;
    }
    /**
     * Set the grid labeler
     *
     * @param labeler
     *            grid labeler
     */
    setLabeler(labeler) {
        this.labeler = labeler;
    }
    /**
     * Is labeler zoom level within the grid zoom range
     *
     * @param zoom
     *            zoom level
     * @return true if within range
     */
    isLabelerWithin(zoom) {
        return this.hasLabeler() && this.labeler.isEnabled() && this.labeler.isWithin(zoom);
    }
    /**
     * Get the label grid edge buffer
     *
     * @return label buffer (greater than or equal to 0.0 and less than 0.5)
     */
    getLabelBuffer() {
        return this.hasLabeler() ? this.labeler.getBuffer() : 0.0;
    }
}
exports.BaseGrid = BaseGrid;
//# sourceMappingURL=BaseGrid.js.map